var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8729 9.60962C19.6942 9.36521 15.4371 3.625 9.9999 3.625C4.56274 3.625 0.305391 9.36521 0.126914 9.60939C-0.0423048 9.84126 -0.0423048 10.1558 0.126914 10.3876C0.305391 10.632 4.56274 16.3723 9.9999 16.3723C15.4371 16.3723 19.6942 10.632 19.8729 10.3878C20.0423 10.156 20.0423 9.84126 19.8729 9.60962ZM9.9999 15.0536C5.99486 15.0536 2.52606 11.2437 1.49922 9.99818C2.52473 8.75157 5.98626 4.94367 9.9999 4.94367C14.0048 4.94367 17.4733 8.7529 18.5006 9.99907C17.4751 11.2456 14.0135 15.0536 9.9999 15.0536Z",
    fill: "#1968B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.04297C7.81868 6.04297 6.04395 7.8177 6.04395 9.99903C6.04395 12.1804 7.81868 13.9551 10 13.9551C12.1813 13.9551 13.9561 12.1804 13.9561 9.99903C13.9561 7.8177 12.1813 6.04297 10 6.04297ZM10 12.6364C8.54571 12.6364 7.36266 11.4533 7.36266 9.99903C7.36266 8.54477 8.54575 7.36168 10 7.36168C11.4543 7.36168 12.6374 8.54477 12.6374 9.99903C12.6374 11.4533 11.4543 12.6364 10 12.6364Z",
    fill: "#1968B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.0d788f23d5a09567231d4cf6cb19e998.svg";
export { ForwardRef as ReactComponent };